import { defineComponent as _defineComponent } from 'vue'
import TransitionFade from 'JS/components/transitions/TransitionFade.vue';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { SalesFlyerPageResource } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerLightboxViewMobile',
  props: {
    pages: null,
    currentPageIndex: null
  },
  emits: ["update:currentPageIndex"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update:currentPageIndex', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	pages: SalesFlyerPageResource[],
	currentPageIndex: number;
}





const currentPageIndex = computed({
	get: () => props.currentPageIndex,
	set: (index) => emit('update:currentPageIndex', index),
});

const containerEl = ref<HTMLElement | undefined>();
const pageEls = ref<HTMLElement[] | undefined>();

const HELP_STORAGE_KEY = 'sales-flyer-mobile-lightbox-has-shown-help';

const initialized = ref(false);
onMounted(() => {
	scrollImageIntoView(props.currentPageIndex, { behavior: 'instant' });
	initialized.value = true;

	// the initial scroll event, which would otherwise hide the message immediately
	// when opened to a page > 1
	setTimeout(() => {
		initHelpMessage();
	}, 100);
});

const showHelpMessage = ref(false);
function initHelpMessage() {
	if (sessionStorage.getItem(HELP_STORAGE_KEY) === 'true') {
		return;
	}

	showHelpMessage.value = true;
	sessionStorage.setItem(HELP_STORAGE_KEY, 'true');

	setTimeout(() => {
		showHelpMessage.value = false;
	}, 3500);
}

function hideHelpMessage() {
	if (!initialized.value || !showHelpMessage.value) {
		return;
	}

	showHelpMessage.value = false;
}

function scrollImageIntoView(index: number, { behavior = 'smooth' }: { behavior?: ScrollBehavior } = {}) {
	pageEls.value?.[index]?.scrollIntoView({ behavior });
	// don't wait for IntersectionObserver to update it. That makes the buttons feel unresponsive
	currentPageIndex.value = index;
}

// updates the page number indicator when user scrolls through
watchEffect((onCleanup) => {
	if (!containerEl.value) {
		return;
	}

	const io = new IntersectionObserver(entries => {
		for (const entry of entries) {
			if (entry.isIntersecting) {
				currentPageIndex.value = +(entry.target as HTMLElement).dataset.pageIndex;
			}
		}
	}, {
		root: containerEl.value,
		threshold: 1,
	});

	const unwatchPageEls = watchEffect((onCleanup) => {
		if (!pageEls.value) {
			return;
		}

		for (const el of pageEls.value) {
			io.observe(el);
		}

		onCleanup(() => {
			for (const el of pageEls.value) {
				io.unobserve(el);
			}
		});
	});

	onCleanup(() => {
		unwatchPageEls();
		io.disconnect();
	});
});

/**
 * Apply loader="eager" to the current, previous, next images. Essentially
 * preloading the surrounding images
 */
function getLoadingAttr(index: number) {
	const previous = currentPageIndex.value - 1;
	const next = currentPageIndex.value + 1;
	return previous <= index && index <= next ? 'eager' : 'lazy';
}

const loadedImagesByPageId = ref<Record<number, boolean>>({});

function handleImageLoad(pageId: number) {
	loadedImagesByPageId.value = {
		...loadedImagesByPageId.value,
		[pageId]: true,
	};
}


return { __sfc: true,props, emit, currentPageIndex, containerEl, pageEls, HELP_STORAGE_KEY, initialized, showHelpMessage, initHelpMessage, hideHelpMessage, scrollImageIntoView, getLoadingAttr, loadedImagesByPageId, handleImageLoad, TransitionFade }
}

})